import React from 'react';
import { connect } from 'react-redux';

import { BaseStore } from 'src/store';
import { classes } from 'src/utils/styles';
import { RetailerEntity, OnStoreHover, ActiveRetailer, RetailerCard } from 'src/modules/retailer';
import { getVisibleRetailers } from '../../store/selectors';
import styles from './RetailerList.module.scss';

interface RetailerListProps {
  retailers: RetailerEntity[];
  onRetailerHover: OnStoreHover;
  activeRetailer: ActiveRetailer;
  containerRef?: any;
}

const RetailerList: React.FunctionComponent<RetailerListProps> = (props: RetailerListProps) => {
  const { retailers = [], onRetailerHover, activeRetailer } = props;

  // const ref = useRef() as React.MutableRefObject<HTMLInputElement>;
  // If the store is active, scroll to it to display it at the top of the Store List. Run only when activeRetailer changes
  // useEffect(() => {
  //   if (activeRetailerId === id && ref && scroll) {
  //     ref.current.scrollIntoView({
  //       behavior: 'smooth',
  //       block: 'start',
  //     });
  //   }
  // }, [activeRetailerId, id, scroll]);

  return (
    <div className={styles.storeList} ref={props.containerRef}>
      {retailers.map((store, idx) => (
        <div
          // ref={activeRetailerId === store.id ? ref : null}
          key={idx}
          className={classes([
            styles.cardContainer,
            // activeRetailerId === store.id ? styles.active : '',
          ])}>
          <RetailerCard
            data={store}
            className={styles.card}
            onRetailerHover={onRetailerHover}
            activeRetailer={activeRetailer}
          />
        </div>
      ))}
    </div>
  );
};

const mapStateToProps = (state: BaseStore) => {
  return getVisibleRetailers(state);
};
export default connect(mapStateToProps, null)(RetailerList);
